/*A collection of user objects*/
import User from "@/types/User/User";
class UserList {
    users = []; // the collection of users.
    constructor(jsonData) {
        if (jsonData !== null) {
            try {
                jsonData.forEach((user) => {
                    this.users.push(new User(user)); //adds a new user to the array
                });
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/UserList -> constructor');
            }
        }
    }
    getUser(userId) {
        return this.users.filter((user) => user.id === userId);
    }
}
export default UserList;
